import { Cog } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const equipmentNav: NavEntry = {
  label: 'Equipment',
  icon: Cog,
  path: '/equipment',
  permission: 'equipment:read',
  order: 17,
}
